import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';

import {BOOKING_CREATE_SECTIONS} from 'components/BookingCreateModal';

import './styles.css';

interface BookingFormsNavigationProps {
  selectedSection: string;
  changeSelectedSection: (string) => void;
}

const BookingFormsNavigation = ({
  selectedSection,
  changeSelectedSection
}: BookingFormsNavigationProps) => (
  <div className="BookingFormsNavigation">
    {_.keys(BOOKING_CREATE_SECTIONS).map(key => (
      <div
        key={key}
        className={classNames('navigationItem', {
          selected: key === selectedSection
        })}
        onClick={() => changeSelectedSection(key)}>
        {BOOKING_CREATE_SECTIONS[key]}
      </div>
    ))}
  </div>
);

export default BookingFormsNavigation;
